<div class="flex">
  <p-floatLabel>
    <p-dropdown
      id="seletorEndpoint"
      [options]="endpoints"
      [(ngModel)]="endpointAtual"
      optionLabel="nome"
      optionValue="id"
      [placeholder]="placeholder"
      [disabled]="disabled || loading"
      [style]="{'width':'100%', 'min-width':'200px'}"
      appendTo="body"
      [filter]="true"
      filterBy="nome,path"
      (onChange)="onEndpointChange($event)"
      emptyMessage="Nenhum endpoint disponível">
      <ng-template pTemplate="selectedItem" let-item>
        <div *ngIf="item">
          <span>{{ item.nome }}</span>
          <span class="text-xs text-gray-500 ml-2">{{ item.path }}</span>
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-endpoint>
        <div class="flex align-items-center justify-content-between">
          <div>
            <div class="flex align-items-center">
              <p-tag [value]="endpoint.metodo" [severity]="getMetodoSeverity(endpoint.metodo)" class="mr-2" />
              <span>{{ endpoint.nome }}</span>
            </div>
            <div class="text-xs text-gray-500 mt-1">{{ endpoint.path }}</div>
          </div>
          <p-tag *ngIf="endpoint.tipoApi !== 'JSON'" [value]="endpoint.tipoApi" severity="secondary" class="ml-2" />
        </div>
      </ng-template>
    </p-dropdown>
    <label for="seletorEndpoint">{{ label }}</label>
  </p-floatLabel>
</div>
